import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRequest,
  postRequest,
  // putRequest,
  patchRequest,
  deleteRequest,
} from "../../services";
import {
  decryptMessage,
  encryptMessage,
} from "../../services/encryption.decryption";
import toaster from "../../utilities/toaster";

export const getAllMachineData = createAsyncThunk(
  "machine/getMachines",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getAllAssignedMachineData = createAsyncThunk(
  "machine/getAssignedMachines",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getAllUnassignedMachineData = createAsyncThunk(
  "machine/getUnassignedMachines",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

// export const getMachineLogs = createAsyncThunk(
//   "machine/getMachineLogs",
//   ({ endPoint }: { endPoint: String }) => {
//     return getRequest(endPoint)
//       .then((res) => res)
//       .catch((err) => {
//         console.error(err);
//       });
//   }
// );


export const getOverallMachineLogs = createAsyncThunk(
  "machine/overall-logs",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getSpecificMachineLogs = createAsyncThunk(
  "machine/specific-logs",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getMachineLogs = createAsyncThunk(
  "machine/log",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getMachineData = createAsyncThunk(
  "machine",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const postCreateMachineData = createAsyncThunk(
  "machine/createMachine",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const putMachineData = createAsyncThunk(
  "machine/updateMachine",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return patchRequest(endPoint, putData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const deleteMachineData = createAsyncThunk(
  "machine/deleteMachine",
  ({ endPoint }: { endPoint: String }) => {
    return deleteRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);


export const postUpsertMachineDoc = createAsyncThunk(
  "machine/upsertDocument",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

type SliceState = {
  loading: boolean;
  JwtToken: string;
  loginData: null | "" | Object;
  createMachineData: null | "" | Object;
  allMachineData: null | "" | Object;
  allAssignedMachineData: null | "" | Object;
  allUnassignedMachineData: null | "" | Object;
  // allMachineLogs: null | "" | Object;
  overallMachineLogs: null | "" | Object;
  specificMachineLogs: null | "" | Object;
  machineLogData: null | "" | Object;
  deleteMachineData: null | "" | Object;
  updateMachineData: null | "" | Object;
  viewMachineData: null | "" | Object;
  upsertDocument: null | "" | Object;
};

const initialState: SliceState = {
  loading: false,
  JwtToken: "",
  loginData: "",
  createMachineData: "",
  allMachineData: [],
  allAssignedMachineData: [],
  allUnassignedMachineData: "",
  // allMachineLogs: "",
  overallMachineLogs: "",
  specificMachineLogs: [],
  machineLogData: "",
  deleteMachineData: "",
  updateMachineData: "",
  viewMachineData: "",
  upsertDocument: "",
};

const machineSlice = createSlice({
  name: "machine",
  initialState,
  reducers: {
    setToken(state, action) {
      state.JwtToken = action.payload;
    },
  },
  extraReducers: (builder) => {
    //TODO: Get API CALL START
    builder.addCase(getAllMachineData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllMachineData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.allMachineData = data?.data;
      } else {
        console.log(data?.status);
        state.allMachineData = data?.data;
      }
    });
    builder.addCase(getAllMachineData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getAllAssignedMachineData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllAssignedMachineData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.allAssignedMachineData = data?.data;
      } else {
        console.log(data?.status);
        state.allAssignedMachineData = data?.data;
      }
    });
    builder.addCase(getAllAssignedMachineData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getAllUnassignedMachineData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllUnassignedMachineData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.allUnassignedMachineData = data?.data;
      } else {
        console.log(data?.status);
        state.allUnassignedMachineData = data?.data;
      }
    });
    builder.addCase(getAllUnassignedMachineData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getOverallMachineLogs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getOverallMachineLogs.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.overallMachineLogs = data?.data;
      } else {
        console.log(data?.status);
        state.overallMachineLogs = data?.data;
      }
    });
    builder.addCase(getOverallMachineLogs.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getSpecificMachineLogs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSpecificMachineLogs.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.specificMachineLogs = data?.data;
      } else {
        console.log(data?.status);
        state.specificMachineLogs = data?.data;
      }
    });
    builder.addCase(getSpecificMachineLogs.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getMachineLogs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMachineLogs.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.machineLogData = data?.data;
      } else {
        console.log(data?.status);
        state.machineLogData = data?.data;
      }
    });
    builder.addCase(getMachineLogs.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getMachineData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMachineData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.viewMachineData = data?.data;
      } else {
        console.log(data?.status);
        state.viewMachineData = data?.data;
      }
    });
    builder.addCase(getMachineData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Put API CALL START
    builder.addCase(putMachineData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putMachineData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        toaster("success", data?.message);
        state.updateMachineData = data;
      } else {
        data?.message ? toaster("error", data?.message) : toaster("error", data?.errors[0].msg);
        console.log(data?.status);
      }
    });
    builder.addCase(putMachineData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Put API CALL END

    //TODO: Post API CALL START
    builder.addCase(postCreateMachineData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postCreateMachineData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));

      console.log("data", data);
      if (data?.status) {
        toaster("success", data?.message);
        state.createMachineData = data;
      } else {
        data?.message ? toaster("error", data?.message) : toaster("error", data?.errors[0].msg);
        console.log(data?.status);
      }
    });
    builder.addCase(postCreateMachineData.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: Post API CALL START
    builder.addCase(postUpsertMachineDoc.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postUpsertMachineDoc.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));

      console.log("data", data);
      if (data?.status) {
        toaster("success", data?.message);
        state.upsertDocument = data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(postUpsertMachineDoc.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: DEL API CALL START
    builder.addCase(deleteMachineData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteMachineData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      console.log("data", data);
      if (data?.status) {
        toaster("success", data?.message);
        state.deleteMachineData = data?.data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(deleteMachineData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: DEL API CALL END
  },
});

export const machineActions = machineSlice.actions;

export default machineSlice;
